var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extension)?_c('v-btn',{nativeOn:{"click":function($event){$event.stopPropagation();return _vm.pay.apply(null, arguments)}}},[_c('v-chip',[_c('price',{staticClass:"mr-2",attrs:{"value":_vm.extension.state.credits,"currency":_vm.platform.currency}}),_vm._v("\n    Recharger\n  ")],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2805f0d9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/extensions/credit/value.vue
// module id = null
// module chunks = 